import LocationInput from './LocationInput';

export default LocationInput;
